import { merge } from 'lodash';
import * as ActionTypes from '../actions';
import * as ActionPartnerTypes from '../actions/partner';
import * as EventTypes from '../actions/internal';
import * as CommunicationTypes from '../actions/communication';

const defaultState = {
  accounts: {
    ages: null,
    cohorts: null,
    groups: null,
    archived: false,
    order: null,
    page: 1,
    partners: null,
    sort: null,
    q: null,
    totalCount: 0,
    totalPages: 1,
  },
  accountPlayer: {
    periods: {
      engagement: null,
      interactivity: null,
    },
    plays: {
      order: null,
      page: 1,
      sort: null,
      totalCount: 0,
      totalPages: 1,
    },
    tabs: {
      idx: 0,
      anchor: null,
    },
  },
  accountPlayers: {
    accounts: null,
    ages: null,
    cohorts: null,
    groups: null,
    end: null,
    archived: false,
    unread: false,
    order: null,
    page: 1,
    partners: null,
    sort: null,
    start: null,
    q: null,
    totalCount: 0,
    totalPages: 1,
  },
  accountPlayersPreview: {
    totalCount: 0,
    totalPages: 1,
  },
  dashboard: {
    ages: null,
    cohorts: null,
    groups: null,
    partners: null,
    periods: {
      account: 'week',
      asq: 'week',
      asqstats: 'week',
      engagement: 'week',
      interactivity: 'week',
    },
  },
  groupCohorts: {
    withages: true,
    groups: null,
    withcohorts: true,
    page: 1,
    totalCount: 0,
    totalPages: 1,
    start: null,
    end: null,
  },
  groupCohortsByOrganizationType: {
    withages: true,
    page: 1,
    totalCount: 0,
    totalPages: 1,
    organizationTypes: null,
    start: null,
    end: null,
  },
  surveys: {
    asq: '',
    cohorts: null,
    groups: null,
    order: null,
    page: 1,
    player: null,
    recent: true,
    concern: false,
    sort: null,
    teacher: null,
    totalPages: 1,
    q: null,
  },
  communication: {
    conversations: {
      page: 1,
      totalPages: 1
    }
  }
};

export default function meta(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SURVEYS_RECEIVE:
      return { ...state, surveys: action.payload.meta };

    case ActionTypes.PLAYERS_FILTER_RECEIVE:
      if (action.meta.source === 'modal') return state;
      return { ...state, surveys: { ...state.surveys, q: action.meta.q } };

    case ActionPartnerTypes.ACCOUNTS_RECEIVE:
      return { ...state, accounts: action.payload.meta };

    case ActionPartnerTypes.ACCOUNT_PLAYERS_RECEIVE:
      if (action.meta.from === 'account') return { ...state, accountPlayersPreview: action.payload.meta };
      return { ...state, accountPlayers: action.payload.meta };

    case ActionPartnerTypes.DASHBOARD_UPDATE_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_RECEIVE:
      return { ...state, dashboard: action.payload.meta };

    case ActionPartnerTypes.DASHBOARD_ACCOUNT_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ENGAGEMENT_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_INTERACTIVITY_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ASQ_RECEIVE:
    case ActionPartnerTypes.DASHBOARD_ASQ_STATS_RECEIVE:
      return { ...state, dashboard: merge({}, state.dashboard, action.meta) };

    case ActionPartnerTypes.ACCOUNT_PLAYER_RECEIVE:
    case ActionPartnerTypes.ACCOUNT_PLAYER_PLAYS_RECEIVE:
      return { ...state, accountPlayer: merge({}, state.accountPlayer, action.payload.meta) };

    case ActionPartnerTypes.ACCOUNT_PLAYER_FREE_PLAYS_RECEIVE:
      return { ...state, accountPlayer: merge({}, state.accountPlayer, action.payload.meta) };

    case ActionPartnerTypes.ACCOUNT_PLAYER_ENGAGEMENT_RECEIVE:
    case ActionPartnerTypes.ACCOUNT_PLAYER_INTERACTIVITY_RECEIVE:
      return { ...state, accountPlayer: merge({}, state.accountPlayer, action.meta) };

    case ActionPartnerTypes.REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_RECEIVE:
      return { ...state, groupCohortsByOrganizationType: action.payload.meta };

    case ActionPartnerTypes.REPORT_GROUP_COHORT_RECEIVE:
      return { ...state, groupCohorts: action.payload.meta };

    case EventTypes.GH_COLUMNS_VISIBILITY_CHANGED:
      return { ...state, groupCohorts: { ...state.groupCohorts, withages: action.meta.options } };

    case EventTypes.AP_TAB_CHANGED:
      return { ...state, accountPlayer: { ...state.accountPlayer, tabs: action.meta } };

    default:
      return state;
  }
}
